import React from 'react';

const styles = require('./card.module.scss');

export default function Card(props) {
  return <div className={styles.main}>{props.children}</div>;
}
